<template>
  <div class="home">
    <div class="content">
      <div class="menuClass" :class="table ? 'menuClass2' : ''">
        <div class="menuTitle">
          <!-- <img :src="avatar" alt /> -->
          点石成金
        </div>
        <el-row class="tac">
          <el-col :span="24">
            <!--<h5>自定义颜色</h5>-->
            <!-- <el-menu default-active="1-4-1" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" :collapse="isCollapse"> -->
            <el-menu
              default-active="2"
              class="el-menu-vertical-demo"
              @open="handleOpen"
              @close="handleClose"
              :collapse="table"
              background-color="#001529"
              text-color="#fff"
              active-text-color="#ffd04b"
              :router="true"
              :default-active="$route.path"
            >
              <!-- <el-menu-item index="/index">
                <i class="el-icon-s-home"></i>
                <span slot="title">首页</span>
              </el-menu-item> -->
              <el-menu-item
                index="/user"
                v-show="[1, 2, 5, 7].includes(accountType)"
              >
                <i class="el-icon-user-solid"></i>
                <span slot="title">员工列表</span>
              </el-menu-item>
              <el-menu-item
                index="/customer"
                v-show="[1, 2, 3].includes(accountType)"
              >
                <i class="el-icon-s-custom"></i>
                <span slot="title">客户管理</span>
              </el-menu-item>
              <el-menu-item
                index="/orderList"
                v-show="![7, 8].includes(accountType)"
              >
                <i class="el-icon-s-claim"></i>
                <span slot="title">贷款申请单列表</span>
              </el-menu-item>
              <el-submenu index="1" v-show="[1, 7, 8].includes(accountType)">
                <template slot="title">
                  <i class="el-icon-s-order"></i>
                  <span>贷后管理</span>
                </template>
                <el-menu-item index="/informationList"
                  >放款信息列表</el-menu-item
                >
                <el-menu-item index="/expiringCustomers"
                  >近期到期客户</el-menu-item
                >
                <el-menu-item index="/birthday">生日提醒</el-menu-item>
              </el-submenu>
              <el-menu-item index="/shopIndustry">
                <i class="el-icon-s-grid"></i>
                <span slot="title">类型管理</span>
              </el-menu-item>
              <el-menu-item index="/businessResource"  v-show="[1,2,3,5,6,7,8].includes(accountType)">
                <i class="el-icon-s-shop"></i>
                <span slot="title">商业资源</span>
              </el-menu-item>
            </el-menu>
          </el-col>
        </el-row>
      </div>
      <section class="sectionClass">
        <div class="box">
          <div class="l">
            <!-- <i class="el-icon-s-fold" @click="update"></i> -->
          </div>
          <div class="t"></div>
          <div class="r">
            <div class="r1">
              <el-badge class="item" style="margin-right: 40px"> </el-badge>
              <el-menu
                class="el-menu-demo"
                mode="horizontal"
                @select="handleSelect"
              >
                <el-submenu index="2">
                  <template slot="title"
                    ><img
                      style="margin-right: 10px"
                      width="40px"
                      height="40px"
                      :src="avatar"
                      alt=""
                    />{{ name }}</template
                  >
                  <el-menu-item index="2-1">修改个人信息</el-menu-item>
                  <el-menu-item index="2-2">退出登录</el-menu-item>
                </el-submenu>
              </el-menu>
            </div>
          </div>
        </div>
        <router-view></router-view>
      </section>
    </div>
    <el-dialog
      title="修改个人信息"
      :visible.sync="updatePasswordShow"
      width="500px"
      :before-close="handleClose2"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="头像">
          <el-upload
            class="avatar-uploader"
            :action="'https://api.dscj2016.com/api/upload/index'"
            :show-file-list="false"
            :on-success="orderCreateImageSuccess"
            :before-upload="orderCreateImageUpload"
            name="file"
            multiple
            :headers="{ token: token || '' }"
            accept="image/jpg,image/jpeg,image/png"
          >
            <img v-if="form.avatar" :src="form.avatar" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input
            type="password"
            v-model="form.pwd"
            placeholder="不输入则密码不变"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose2">取 消</el-button>
        <el-button type="primary" @click="updatePasswordSubmit"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Cookie from "js-cookie";
export default {
  data() {
    return {
      userName: "aaa用户",
      accountType: "",
      avatar: "",
      name: "",
      token: "",
      updatePasswordShow: false,
      form: {
        name: "",
        avatar: "",
        pwd: "",
      },
      rules: {
        name: [{ required: true, message: "请选择", trigger: "blur" }],
        avatar: [{ required: true, message: "请选择", trigger: "change" }],
      },
    };
  },
  computed: {
    ...mapState({
      table: (state) => state.indexData.isNag,
    }),
  },
  created() {},
  methods: {
    ...mapActions(["my_menu", "postRoleRolename"]),
    handleSelect(e) {
      if (e == "2-1") {
        this.updatePasswordShow = true;
        this.form.name = this.name;
        this.form.avatar = this.avatar;
      } else {
        this.exit();
      }
    },
    updatePasswordSubmit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$axios
            .post("/api/admin/modifySelf", this.$qs.stringify(this.form))
            .then((res) => {
              if (res.data.code == 1) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                Cookie.set("avatar", this.form.avatar);
                Cookie.set("name", this.form.name);
                this.name = this.form.name;
                this.avatar = this.form.avatar;
                this.handleClose2();
              } else {
                this.$message.error(res.data.msg);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleClose2() {
      this.updatePasswordShow = false;
      this.form = {
        name: "",
        avatar: "",
        pwd: "",
      };
    },
    orderCreateImageSuccess(res, file) {
      this.form.avatar = res.data;
    },
    orderCreateImageUpload() {},
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    update() {
      if (this.table) {
        this.$store.commit("updateIsNage", false);
      } else {
        this.$store.commit("updateIsNage", true);
      }
    },
    exit() {
      this.$axios.post("/api/logout/index").then((res) => {
        if (res.data.code == 1) {
          Cookie.set("avatar", "");
          Cookie.set("name", "");
          Cookie.set("roleType", "");
          Cookie.set("token", "");
          this.$router.push("/login");
        }
      });
    },
  },

  mounted() {
    this.name = Cookie.get("name");
    this.avatar = Cookie.get("avatar");
    this.token = Cookie.get("token");
    setTimeout(() => {
      this.accountType = Number(Cookie.get("roleType"));
    }, 100);
  },
};
</script>
<style lang="scss" scoped>
.avatar-uploader {
  ::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.el-menu-demo {
  ::v-deep .el-submenu .el-submenu__title,
  ::v-deep .el-menu--horizontal {
    border: none;
  }
}

.box11 {
  ::v-deep .el-dialog__header {
    padding: 0;
  }
  ::v-deep .el-dialog__body {
    padding: 0;
  }
}
.menuClass {
  width: 200px;
  height: 100%;
  transition: all 1s;
  .menuTitle {
    width: 200px;
    height: 80px;
    // display: flex;
    // align-items: center;
    background: #ffffff;
    transition: all 1s;
    color: #ffffff;
    font-size: 28px;
    text-align: center;
    line-height: 80px;
    background-color: rgb(20, 21, 40);
    img {
      width: 100px;
      height: 60px;
      margin: 0 auto;
    }
    & > div {
      color: #e6e6e6;
      font-size: 20px;
      font-weight: 600;
    }
  }
}
.menuClass2 {
  width: 70px !important;
  transition: all 1s;
  .menuTitle {
    width: 69px !important;
    transition: all 1s;
  }
}

.box {
  width: calc(100% - 200px);
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 5px 5px -5px #5e5e5e;
  background: rgba(255, 255, 255, 1);
  color: #fff;
  position: fixed;
  z-index: 99;
  .l {
    width: 60px;
    height: 100%;
    line-height: 80px;
    font-size: 24px;
    color: black;
    padding-left: 30px;
    i {
      cursor: pointer;
    }
  }
  .t {
    color: #00284d;
    font-weight: 600;
    font-size: 28px;
  }
  .r {
    height: 100%;
    width: auto;
    display: flex;
    align-items: center;
    padding-right: 30px;

    .r1 {
      display: flex;
      align-items: center;
      padding-right: 10px;
      .r11 {
        width: 40px;
        height: 40px;
        margin-right: 3px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .r12 {
        color: black;
      }
    }
    .r2 {
      width: 80px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-left: 1px solid gray;
      img {
        width: 40px;
        height: 40px;
      }
    }
  }
}
.home {
  height: 100%;
  display: flex;
  flex-direction: column;
  .header {
    height: 60px;
    background: #545c64;
    display: flex;
    color: white;
    justify-content: center;
    align-items: center;
    .el-dropdown {
      font-size: 12px;
      height: 65px;
      color: white;
    }
    & > div {
      width: 50%;
      height: 100%;
      float: left;
      line-height: 60px;
      font-size: 24px;
    }
    & > div:first-of-type {
      padding-left: 50px;
    }
    & > div:last-of-type {
      text-align: right;
      padding-right: 50px;
      & > span:last-of-type {
        font-weight: 600;
      }
    }
  }
  .el-dropdown-menu .el-popper {
    top: 59px !important;
  }
  .content {
    flex: 1;
    display: flex;
    overflow: hidden;
    height: 100%;
    .el-submenu .el-menu-item {
      min-width: 100% !important;
    }
    .tac {
      width: 100%;
      background: rgba(8, 15, 8, 0.1);
      height: calc(100% - 60px);
      display: flex;
      flex-direction: column;
      align-items: center;
      /*justify-content: center;*/
      overflow-y: auto;
      & > div {
        height: 100% !important;
        width: 100%;
        & > ul {
          height: 100% !important;
          width: 100% !important;
        }
      }
    }
    .tac::-webkit-scrollbar {
      width: 0 !important;
    }
    section {
      flex: 1;
      // background: rgba(100, 100, 1, 0.3);
    }
  }
  .sectionClass {
    overflow: auto;
    .baiduQueue {
      padding-top: 100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Home/index.vue